var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.baseComponent,
    {
      tag: "component",
      staticClass: "nav-item",
      class: { active: _vm.isActive },
      attrs: {
        to: _vm.link.path
          ? "#" + _vm.link.path
          : "/" +
            (_vm.link.params !== null && typeof _vm.link.params !== "undefined"
              ? "?" + _vm.link.params
              : ""),
        tag: "li"
      }
    },
    [
      _vm.isMenu
        ? _c(
            "a",
            {
              staticClass: "nav-link sidebar-menu-item",
              attrs: {
                "aria-expanded": !_vm.collapsed,
                "data-toggle": "collapse"
              },
              on: { click: _vm.collapseMenu }
            },
            [
              _c("i", { class: _vm.link.icon }),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n      " + _vm._s(_vm.link.name) + "\n      "),
                _c("b", { staticClass: "caret" })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.default || this.isMenu
        ? _c(
            "div",
            [
              _c("el-collapse-transition", [
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.collapsed,
                        expression: "!collapsed"
                      }
                    ],
                    staticClass: "nav"
                  },
                  [_vm._t("default")],
                  2
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.children.length === 0 && !_vm.$slots.default && _vm.link.path
        ? _vm._t("title", [
            _c(
              _vm.elementType(_vm.link, false),
              {
                tag: "component",
                staticClass: "nav-link",
                class: { active: _vm.link.active },
                attrs: {
                  to:
                    _vm.link.path +
                    (_vm.link.params !== null &&
                    typeof _vm.link.params !== "undefined"
                      ? "?" + _vm.link.params
                      : ""),
                  target: _vm.link.target,
                  href: "#" + _vm.link.path
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.linkClick($event)
                  }
                }
              },
              [
                _vm.addLink
                  ? [
                      _vm.link.icon !== undefined
                        ? [
                            _c(
                              "span",
                              { staticClass: "sidebar-mini" },
                              [
                                Array.isArray(_vm.link.icon)
                                  ? [
                                      _c("font-awesome-icon", {
                                        staticClass: "child-nav",
                                        attrs: { icon: _vm.link.icon }
                                      })
                                    ]
                                  : [
                                      _c("i", {
                                        class: _vm.link.icon + " child-nav"
                                      })
                                    ]
                              ],
                              2
                            )
                          ]
                        : [
                            _c("span", { staticClass: "sidebar-mini" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.link.iconText !== undefined
                                    ? _vm.link.iconText
                                    : _vm.link.name.substring(0, 1)
                                )
                              )
                            ])
                          ],
                      _vm._v(" "),
                      _c("span", { staticClass: "sidebar-normal" }, [
                        _vm._v(_vm._s(_vm.link.name))
                      ])
                    ]
                  : [
                      Array.isArray(_vm.link.icon)
                        ? [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.link.icon }
                            })
                          ]
                        : [_c("i", { class: _vm.link.icon })],
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.link.name))])
                    ]
              ],
              2
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61fadc8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61fadc8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarPlugin/SidebarItem.vue
// module id = +LPU
// module chunks = 4